import { SvgIconProps } from "@material-ui/core";
import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export interface IconProps extends SvgIconProps {
  disable?: boolean;
}

export default (props: IconProps) => {
  const { disable, ...restProps } = props;
  const Checkbox = createSvgIcon(
    <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="15"
        height="15"
        rx="3.5"
        fill={disable ? "#EEEEEE" : "white"}
      />
      <rect
        x="0.5"
        y="0.5"
        width="15"
        height="15"
        rx="3.5"
        stroke={disable ? "#CCCCCC" : "#999999"}
      />
    </svg>,
    "Checkbox"
  );
  return <Checkbox {...restProps} viewBox="0 0 16 16" />;
};
